<div class="language-selector" #dropdownRef>
  <button class="language-selector__trigger" [class.language-selector__trigger--open]="dropdownOpen"
    (click)="toggleDropdown()" [attr.aria-expanded]="dropdownOpen" aria-haspopup="listbox" type="button">

    @if (selectedLanguageFlag()) {
      <span [class]="'fi fi-' + selectedLanguageFlag()" class="language-selector__flag"
        [attr.aria-label]="selectedLanguage()">
      </span>
    }
  </button>
  @if (dropdownOpen) {
    <div
      class="language-selector__overlay"
    (click)="toggleDropdown()"></div>
  }

  <div class="language-selector__dropdown" [class.language-selector__dropdown--open]="dropdownOpen" role="listbox">
    <div class="language-selector__dropdown-content">
      @for (lang of langs(); track trackByLang($index, lang)) {
        <button class="language-selector__option"
          [class.language-selector__option--selected]="lang.lang_name === selectedLanguage()"
          (click)="selectLanguage(lang)" [attr.aria-selected]="lang.lang_name === selectedLanguage()" role="option"
          type="button">
          <span [class]="'fi fi-' + convertToAlpha2Code(lang.lang_name)" class="language-selector__option-flag"
            [attr.aria-label]="lang.lang_name">
          </span>
          <div class="language-selector__option-text">
            <div class="language-selector__option-name">{{ getLanguageDisplayName(lang.lang_name) }}</div>
            <div class="language-selector__option-code">{{ getLanguageCode(lang.lang_name) }}</div>
          </div>
          @if (lang.lang_name === selectedLanguage()) {
            <svg class="language-selector__check" width="16" height="16"
              viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          }
        </button>
      }
    </div>
  </div>
</div>